// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__3NVi0","Content":"Home_Content__11qAo"};